import { render, staticRenderFns } from "./view-expired-booking.vue?vue&type=template&id=2b92d0af&"
import script from "./view-expired-booking.vue?vue&type=script&lang=js&"
export * from "./view-expired-booking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports